var _rect, _rect2, _rect3, _rect4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_2_8204)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint1_linear_2_8204)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#CBE880"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "url(#paint2_linear_2_8204)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7929 20.15C14.0729 20.15 13.3829 20.045 12.7229 19.835C12.0729 19.615 11.5329 19.32 11.1029 18.95L11.7329 17.48C12.6329 18.18 13.6329 18.53 14.7329 18.53C16.0829 18.53 16.7579 18 16.7579 16.94C16.7579 16.44 16.5879 16.07 16.2479 15.83C15.9179 15.58 15.4329 15.455 14.7929 15.455H13.0979V13.865H14.6129C15.1729 13.865 15.6179 13.73 15.9479 13.46C16.2779 13.18 16.4429 12.795 16.4429 12.305C16.4429 11.845 16.2879 11.495 15.9779 11.255C15.6779 11.015 15.2379 10.895 14.6579 10.895C13.6179 10.895 12.7029 11.255 11.9129 11.975L11.2829 10.535C11.7029 10.135 12.2279 9.825 12.8579 9.605C13.4879 9.385 14.1429 9.275 14.8229 9.275C15.9229 9.275 16.7779 9.525 17.3879 10.025C17.9979 10.515 18.3029 11.2 18.3029 12.08C18.3029 12.65 18.1579 13.15 17.8679 13.58C17.5779 14.01 17.1829 14.32 16.6829 14.51C17.2929 14.68 17.7679 14.995 18.1079 15.455C18.4479 15.905 18.6179 16.455 18.6179 17.105C18.6179 18.045 18.2779 18.79 17.5979 19.34C16.9179 19.88 15.9829 20.15 14.7929 20.15Z",
    fill: "#7566E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_8204",
    x1: 26.7,
    y1: 5.08815e-7,
    x2: -2.97369,
    y2: 13.2033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685BC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_8204",
    x1: 26.7,
    y1: 0.00000243427,
    x2: 2.02053,
    y2: 7.0303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7566E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_8204",
    x1: 6.3,
    y1: -1.67856e-8,
    x2: 3.34629,
    y2: 28.6436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeChild);
export default __webpack_public_path__ + "static/media/three-child.3d9f99d945f54f70b170a3ac380240eb.svg";
export { ForwardRef as ReactComponent };